import React from 'react';
import { formatPercent } from './salesUtils';

const ShareRow = ({ label, pct, muted }) => (
  <div className="flex-1 min-w-0">
    <div className="flex items-baseline justify-between gap-2">
      <span className="sales-label">{label}</span>
      <span className={`font-display font-semibold text-xl sales-num ${muted ? 'text-gray-300' : 'text-brand-yellow'}`}>{formatPercent(pct)}</span>
    </div>
    <div className="sales-track mt-2.5">
      <div className={muted ? 'sales-fill-muted' : 'sales-fill'} style={{ width: `${Math.min(100, pct || 0)}%` }} />
    </div>
  </div>
);

// Percentage-point gap between the range share and the all-time share.
// Neutral tone on purpose: a higher or lower share is information, not a verdict.
const Delta = ({ range, allTime }) => {
  const diff = Math.round(((range || 0) - (allTime || 0)) * 10) / 10;
  const text = diff === 0 ? 'Level with all time' : `${diff > 0 ? '+' : '−'}${Math.abs(diff).toFixed(1)} pts vs all time`;
  return (
    <span className="sales-pill self-start sm:self-center normal-case tracking-normal font-medium" data-testid="compare-delta">
      <span aria-hidden="true">{diff > 0 ? '▲' : diff < 0 ? '▼' : '='}</span>
      {text}
    </span>
  );
};

// Revenue share in the selected range vs the video's all-time share.
const CompareStrip = ({ range, allTime }) => (
  <div className="sales-card flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8" data-testid="compare-strip">
    <ShareRow label="Share of revenue, this range" pct={range.pct_of_revenue} />
    <ShareRow label="Share of revenue, all time" pct={allTime.pct_of_revenue} muted />
    <Delta range={range.pct_of_revenue} allTime={allTime.pct_of_revenue} />
  </div>
);

export default CompareStrip;
